(function () {
  'use strict';

  var STORAGE_KEY = 'emd_machine_selection';

  function readSelection() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeSelection(selection) {
    try {
      if (selection) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) { /* localStorage unavailable */ }
    document.dispatchEvent(new CustomEvent('emd:machine:change', { detail: selection }));
  }

  function initInstance(root) {
    var catalogEl = root.querySelector('[data-machine-catalog]');
    var brandSelect = root.querySelector('[data-ms-brand]');
    var submitBtn = root.querySelector('[data-ms-submit]');
    var resetBtn = root.querySelector('[data-ms-reset]');
    var confirmEl = root.querySelector('[data-ms-confirm]');
    if (!catalogEl || !brandSelect) return;

    var catalog = [];
    try { catalog = JSON.parse(catalogEl.textContent) || []; } catch (e) { catalog = []; }

    catalog.forEach(function (brand) {
      var o = document.createElement('option');
      o.value = brand.name;
      o.textContent = brand.name;
      brandSelect.appendChild(o);
    });

    function updateSubmitState() {
      if (submitBtn) {
        submitBtn.disabled = !brandSelect.value;
      }
    }

    function showConfirm(selection) {
      if (!confirmEl) return;
      if (selection && selection.label) {
        var template = root.dataset.confirmTemplate;
        confirmEl.textContent = template ? template.replace('{{ label }}', selection.label) : selection.label;
        confirmEl.hidden = false;
        if (resetBtn) resetBtn.hidden = false;
      } else {
        confirmEl.hidden = true;
        if (resetBtn) resetBtn.hidden = true;
      }
    }

    function applyExistingSelection() {
      var existing = readSelection();
      if (!existing) return;
      brandSelect.value = existing.brand || '';
      updateSubmitState();
      showConfirm(existing);
    }

    brandSelect.addEventListener('change', updateSubmitState);

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!brandSelect.value) return;
        var selection = {
          brand: brandSelect.value,
          label: brandSelect.value
        };
        writeSelection(selection);
        showConfirm(selection);
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        writeSelection(null);
        brandSelect.value = '';
        updateSubmitState();
        showConfirm(null);
      });
    }

    applyExistingSelection();
  }

  document.querySelectorAll('[data-machine-selector]').forEach(initInstance);
})();
